import React from 'react';
import { Box, Typography, Link, Divider } from '@mui/material';
import StockChip from '../shared/StockChip';

/**
 * NewsSection — Compact news list (max 5 articles).
 */
const NewsSection = ({ articles = [], onSymbolClick }) => {
  const displayArticles = articles.slice(0, 5);

  if (displayArticles.length === 0) {
    return (
      <Box sx={{ px: 2, py: 3, textAlign: 'center' }}>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          No recent news
        </Typography>
      </Box>
    );
  }

  const formatTimeAgo = (dateString) => {
    if (!dateString) return '';
    const now = new Date();
    const date = new Date(dateString);
    const diffMs = now - date;
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    if (diffHours < 1) return 'Just now';
    if (diffHours < 24) return `${diffHours}h ago`;
    const diffDays = Math.floor(diffHours / 24);
    return `${diffDays}d ago`;
  };

  return (
    <Box sx={{ px: 2, py: 1.5 }}>
      {displayArticles.map((article, index) => (
        <Box key={article.id || index}>
          <Box sx={{ py: 1.2 }}>
            <Link
              href={article.url}
              target="_blank"
              rel="noopener noreferrer"
              underline="hover"
              sx={{
                fontSize: 13,
                fontWeight: 500,
                color: 'text.primary',
                lineHeight: 1.4,
                display: 'block',
                '&:hover': { color: 'primary.main' },
              }}
            >
              {article.headline}
            </Link>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.8, mt: 0.8, flexWrap: 'wrap' }}>
              {article.symbols?.map((sym) => (
                <StockChip key={sym} symbol={sym} onClick={onSymbolClick} />
              ))}
              {article.source && (
                <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 11 }}>
                  {article.source}
                </Typography>
              )}
              <Typography variant="caption" sx={{ color: 'text.secondary', fontSize: 11, ml: 'auto' }}>
                {formatTimeAgo(article.created_at)}
              </Typography>
            </Box>
          </Box>
          {index < displayArticles.length - 1 && <Divider />}
        </Box>
      ))}
    </Box>
  );
};

export default NewsSection;
